<template>
  <div id="contenedor-tablero-expedientes-listado">
    <v-data-table
      :headers="headers"
      :items="resultados"
      no-data-text="No se encontraron contratos en el rango y filtros seleccionados">
      <template v-slot:[`item.numero`]="{ item }">
        <div class="py-2">
          <div class="font-weight-medium">{{ item.numero }}</div>
          <div class="text-caption grey--text">{{ $moment(item.fecha).format('DD/MM/YYYY') }}</div>
          <v-chip
            v-if="item.estatus"
            x-small
            class="mt-1"
            :color="item.estatus.color"
            :dark="item.estatus.esTextoClaro">
            {{ item.estatus.nombre }}
          </v-chip>
        </div>
      </template>

      <template v-slot:[`item.meta`]="{ item }">
        <v-tooltip top max-width="300">
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="text-truncate d-inline-block"
              style="max-width: 260px;">
              {{ item.meta }}
            </span>
          </template>
          <span>{{ item.meta }}</span>
        </v-tooltip>
        <div class="text-caption grey--text text-truncate" style="max-width: 260px;">
          {{ item.contratista ? item.contratista.nombreRazonSocial : '-' }}
        </div>
      </template>

      <template v-slot:[`item.responsable`]="{ item }">
        {{ getResponsablePrincipal(item) }}
      </template>

      <template v-slot:[`item.totalDocumentos`]="{ item }">
        <div class="text-center">
          <div class="text-caption grey--text">{{ item.totalDocumentos }} documentos</div>
          <div class="d-flex justify-center mt-1">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  x-small
                  color="success"
                  text-color="white"
                  class="mr-1"
                  v-bind="attrs"
                  v-on="on">
                  {{ item.integrados }}
                </v-chip>
              </template>
              <span>Integrados</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  x-small
                  color="warning"
                  text-color="white"
                  class="mr-1"
                  v-bind="attrs"
                  v-on="on">
                  {{ item.faltantes }}
                </v-chip>
              </template>
              <span>Faltantes</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  x-small
                  color="grey lighten-2"
                  text-color="grey darken-1"
                  v-bind="attrs"
                  v-on="on">
                  {{ item.noAplicables }}
                </v-chip>
              </template>
              <span>No Aplica</span>
            </v-tooltip>
          </div>
        </div>
      </template>

      <template v-slot:[`item.porcentajeIntegracion`]="{ item }">
        <div style="min-width: 150px;">
          <div class="d-flex justify-space-between align-center mb-1">
            <span class="text-caption font-weight-medium">
              {{ item.porcentajeIntegracion !== null
                ? `${$numberRound(item.porcentajeIntegracion)}%` : '-' }}
            </span>
            <v-chip
              x-small
              :color="obtenerEstado(item.estadoExpediente).color"
              :dark="obtenerEstado(item.estadoExpediente).dark">
              {{ obtenerEstado(item.estadoExpediente).nombre }}
            </v-chip>
          </div>
          <v-progress-linear
            :value="item.porcentajeIntegracion || 0"
            height="6"
            rounded
            :color="obtenerEstado(item.estadoExpediente).color">
          </v-progress-linear>
        </div>
      </template>

      <template v-slot:[`item.ultimaActualizacion`]="{ item }">
        <span v-if="item.ultimaActualizacion">
          {{ $moment(item.ultimaActualizacion).format('DD/MM/YYYY HH:mm') }}
        </span>
        <span v-else class="grey--text">-</span>
      </template>

      <template v-slot:[`item.acciones`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="verExpediente(item)">
              <v-icon color="primary">mdi-folder-eye-outline</v-icon>
            </v-btn>
          </template>
          <span>Ver expediente</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { obtenerEstado } from '@/helpers/expedienteEstados';

export default {
  name: 'TableroExpedientesListadoDesktop',
  props: {
    resultados: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Contrato', align: 'start', value: 'numero',
        },
        { text: 'Objeto', align: 'start', value: 'meta' },
        {
          text: 'Responsable', align: 'start', value: 'responsable', sortable: false,
        },
        {
          text: 'Documentos', align: 'center', value: 'totalDocumentos',
        },
        {
          text: 'Avance', align: 'center', value: 'porcentajeIntegracion',
        },
        { text: 'Última Actualización', align: 'center', value: 'ultimaActualizacion' },
        {
          text: 'Acciones', align: 'center', value: 'acciones', sortable: false,
        },
      ],
    };
  },
  methods: {
    getResponsablePrincipal(item) {
      const responsable = item.responsables.find(({ principal }) => principal);
      return responsable ? responsable.funcionario.nombre : '-';
    },
    obtenerEstado,
    verExpediente(item) {
      this.$router.push({
        name: 'tableroExpedientesDetalle',
        params: { idContrato: item.id },
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
